import * as React from "react";
import {useEffect} from "react";
import {useSearchParams} from "react-router-dom";

const Module: React.FC = () => {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        window.location.assign("https://console.firebase.google.com/u/0/project/" + searchParams.get("linkedId"));
    }, []);

    return <></>;
};

export default Module;